import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'shards-react'

import '../../invite-accept-screen.css'

export default function ConfirmSolicitationMessage({ miniAppInformations, acceptInvite }) {
    ConfirmSolicitationMessage.propTypes = {
        miniAppInformations: PropTypes.object,
        acceptInvite: PropTypes.func,
    }

    const { miniAppName, email } = miniAppInformations
    return (
        <Fragment>
            <p>Olá, convidado.</p>
            <p>
                Você recebeu um convite do email
                <span className="invite-accept--mini-app-text--bold">{` ${email} `}</span>
                para participar no projeto
            </p>
            <p>
                <span className="invite-accept--mini-app-text--bold">{` ${miniAppName}.`}</span>
            </p>
            <Button id="invite-accept--confirmation-button" onClick={acceptInvite}>
                Confirmar
            </Button>
        </Fragment>
    )
}
